import { render, staticRenderFns } from "./classificationManagement.vue?vue&type=template&id=6d5bc8e4&scoped=true&"
import script from "./classificationManagement.vue?vue&type=script&lang=js&"
export * from "./classificationManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5bc8e4",
  null
  
)

export default component.exports